<h2 mat-dialog-title class="font-weight-bolder">Add Data</h2>
<mat-dialog-content>
  <form [formGroup]="form">
    <h6>URL</h6>
    <div class="add-layer-dialog">
        <mat-form-field class="w-100">
          <input matInput disabled="true" [value]="url" />
          <mat-icon matSuffix class="text-success">done</mat-icon>
        </mat-form-field>


    </div>
    <div class="auth-div">
      <mat-checkbox (change)="setBbox($event)">Only request features overlapping the view extent</mat-checkbox>
    </div>
    <div class="auth-div">
      <span>Does this require authentication?</span>
      <mat-radio-group class="type-radio-group" (change)="onAuthRequireChange($event)">
        <mat-radio-button [value]="true">Yes</mat-radio-button>
        <span class="spacer auth-option-spacer"></span>
        <mat-radio-button [value]="false" [checked]="true">No</mat-radio-button>
      </mat-radio-group>
      <span class="spacer"></span>
    </div>
    <div class="auth-div" *ngIf="isAuthRequired">
      <div class="auth-field add-layer-dialog">
        <mat-form-field>
          <input matInput password  placeholder="Username" formControlName="username" />
        </mat-form-field>
      </div>
      <div class="auth-field add-layer-dialog">
        <mat-form-field>
          <input class="auth-field" matInput  placeholder="Password" [type]="hide ? 'password' : 'text'" formControlName="password" />
          <mat-icon matSuffix (click)="hide = !hide">{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
        </mat-form-field>
      </div>
    </div>
    <app-loading [show]="isLoading" label="Loading data..."></app-loading>
  </form>
  <mat-label #lblError id="lblError" class="error"></mat-label>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="elevated" [mat-dialog-close]="true">Back</button>
  <button matButton="filled" color="primary" (click)="getArcGISFeature()">Next</button>
</mat-dialog-actions>
